import { Anchor, Box, Group, Stack, Text, Title } from "@mantine/core";
import LoginForm from "./LoginForm";
import { Link, Navigate } from "react-router-dom";
import LanguageChanger from "../LanguageChanger";
import { useLanguage } from "../../../stores/LanguageStore";
import { useSessionStore } from "../../../stores/UserStore";
import { useEffect } from "react";
import LogoHorizontalWhite from "../../../layouts/LogoHorizontalWhite";
import { lemonColor } from "../../../stores/ThemeStore";
import LoginDecorations from "./LoginDecorations";
import { Logo } from "../../../layouts/Logo";

const Login = () => {
  const lang = useLanguage((s) => s.language);
  const url = new URLSearchParams(window.location.search);
  const destination = url.get("destination");
  const reseller = useSessionStore((s) => s.reseller);

  const session = useSessionStore((s) => s.session);
  const params = window.location.href.split("?")?.[1];

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  document.title = `${lang.login.title} - ${
    useSessionStore.getState().reseller?.name || ""
  }`;

  if (
    session &&
    !params?.includes("destination") &&
    !params?.includes("logged_out=true")
  )
    return <Navigate to={"/" + (params ? `?${params}` : "")} />;

  return (
    <Group
      w={"100vw"}
      h={"100vh"}
      gap={0}
      bg={"#392b5f"}
      align="stretch"
      c={"#392b5f"}
      style={{ overflow: "hidden" }}
    >
      <Stack
        w={"50%"}
        px={100}
        justify="start"
        h={"100%"}
        pos={"relative"}
        style={{ zIndex: 8 }}
        bg={"primary.9"}
        display={{ lg: "flex", base: "none" }}
      >
        <Box h={100} maw={350} mb={96} pos={"absolute"} top={48}>
          <LogoHorizontalWhite />
        </Box>
        {/* <Logo /> */}

        <Title order={4} pl={100} mt={256} fz={44} lh={1.4} c={"white"}>
          {lang.login.title1} {lang.id === "FRA" && <br />}
          <span
            style={{
              color: lemonColor,
            }}
          >
            {lang.login.title2}
          </span>{" "}
          {lang.login.title3}{" "}
          {lang.id === "FRA" && (
            <>
              {" "}
              <br /> {lang.login.title4} <br />
            </>
          )}
          <span
            style={{
              color: lemonColor,
            }}
          >
            {lang.login.title5}
          </span>
        </Title>

        <Text c={"white"} mt={"auto"} mb={32}>
          {reseller?.name || "Magileads"} • {new Date().getFullYear()}
        </Text>
      </Stack>

      <Stack
        flex={1}
        p={{ base: 0, lg: "lg" }}
        bg={reseller?.name !== "Magileads" ? "primary.0" : "#f1e9fe"}
        justify="center"
        align="center"
        pos={"relative"}
      >
        <Stack w={{ base: "90%", lg: "60%" }} gap={"xs"} style={{ zIndex: 8 }}>
          {window.innerWidth < 768 && (
            <Box
              h={100}
              maw={200}
              mb={96}
              pos={"absolute"}
              top={16}
              style={{ zIndex: 9 }}
            >
              <Logo />
            </Box>
          )}
          <Title order={1} className={`animate__animated animate__fadeIn`}>
            {lang.login.title}
          </Title>

          <Text
            className={`animate__animated animate__fadeIn`}
            style={{ animationDelay: ".4s" }}
          >
            {lang.login.new_user}{" "}
            <Anchor component={Link} to={"/signup"} size="lg" fw={"bold"}>
              {lang.login.create_account}
            </Anchor>
          </Text>
          {destination && <Text c={"red"}>{lang.login.need_reconnect}</Text>}

          <LoginForm />
        </Stack>

        <LoginDecorations />
      </Stack>
      <LanguageChanger />
    </Group>
  );
};

export default Login;
